import { getStoryBySlug } from "@cinch-nx/data-storyblok";
export const getPolicyPageContentData = async (slug, preview = false)=>{
    const story = await getStoryBySlug(`policies/${slug}`, {
        version: preview ? "draft" : "published",
        cv: Date.now()
    });
    return story ?? undefined;
};
